import { UserTypes } from "../../../redux/_types/user/types";

export const UserTypeLabels = {
    [UserTypes.BRANCH_ADMIN]: "Branch Admin",
    [UserTypes.BRANCH_STAFF]: "Branch Staff",
    [UserTypes.COMPANY_ADMIN]: "Company Admin",
    [UserTypes.GYA_ADMIN]: "Kriva Admin",
    [UserTypes.VENDOR]: "Vendor"
};
